import { render, staticRenderFns } from "./HistoryLearning.vue?vue&type=template&id=66f05577&scoped=true&lang=pug&"
import script from "./HistoryLearning.vue?vue&type=script&lang=ts&"
export * from "./HistoryLearning.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryLearning.vue?vue&type=style&index=0&id=66f05577&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f05577",
  null
  
)

export default component.exports